import React, {useState, useEffect, useContext} from 'react';
import { toast } from 'react-toastify';
import { Form, Input, InputGroup } from 'reactstrap';
import { finishRegistration, isTokenValid } from 'utils/api/authApi';
import { connect } from 'react-redux';
import { login, setPermissions, logoutWithoutRedirect } from 'redux/modules/auth/action';
import momentTZ from 'moment-timezone';
import SpinnerButton from 'components/SpinnerButton';
import {useHistory} from 'react-router-dom';
import InputWithError from 'components/InputWithError';
import {ErrorContext} from 'contexts/ErrorContext';

const InviteUserPage = (props) => {
    let history = useHistory();
    const {handleErrors} = useContext(ErrorContext);

    const [passwordFirst, setFirstPassword] = useState('');
    const [passwordSecond, setSecondPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [checkingToken, setCheckingToken] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        checkToken();
    }, [])

    const checkToken = async() => {
        try {
            console.log("CHECKING TOKEN")
            const href = window.location.href;
            const count = href.indexOf('token=');
            const token = href.substring(count).replace('token=', '');
            let tokenCheck = await isTokenValid(token);
            if(!tokenCheck.content.token) {
                // setTokenInvalid(true);
                history.push('/link-expired');
            }
            setCheckingToken(false);
        } catch(err) {
            console.log(err);
            // setCheckingToken(false);
            history.push('/404')
        }
    };

    const validation = (value, type) => {
        if (value.split('')[0] === ' ' || value.split('')[value.length - 1] === ' ') {
            return false;
        }

        if (type === 'first') {
            setFirstPassword(value);
        } else {
            setSecondPassword(value);
        }
    };

    const getBrowserTimezone = () => {
        return momentTZ.tz.guess();
    }

    const handleSubmit = async() => {
        try {
            setSubmitting(true);

            const href = window.location.href;
            const count = href.indexOf('token=');
            const token = href.substring(count).replace('token=', '');
            const timezone = getBrowserTimezone();

            const params = {
                isCreatedAccount: true,
                token,
                plainPassword: {
                    first: passwordFirst,
                    second: passwordSecond,
                },
                timezone: timezone ? timezone : null,
                isSingleUser: false,
            };

            console.log(params)
            const user = await finishRegistration(params);
            console.log(user)
            await props.login(user.content.email, passwordFirst);
            console.log('done')
            // await props.setPermissions();
            history.push('/');
            // setSubmitting(false);
        } catch (err) {
            setSubmitting(false);
            handleErrors(err, setError);
        }
    };

    if(checkingToken) return null;
    return (
        <div className="finish_reg-container flex-centered">
            <h3 style={{ fontWeight: '700', marginBottom: '0.5rem' }}>
                Finish Registration
            </h3>
            <p style={{ marginBottom: '0' }}>Create password</p>
            <div className="authorization-container">
                <InputWithError
                    placeholder="Password"
                    name="password"
                    value={passwordFirst}
                    type="password"
                    onChange={setFirstPassword}
                    errorObj={error}
                    prependIcon={<i className="fas fa-unlock-alt"/>}
                    marginBottomClass="mb-3"
                    // onPressEnter={handleSubmit}
                />
                <InputWithError
                    placeholder="Confirm Password"
                    name="plainPassword"
                    value={passwordSecond}
                    type="password"
                    onChange={setSecondPassword}
                    errorObj={error}
                    prependIcon={<i className="fas fa-unlock-alt"/>}
                    marginBottomClass="mb-3"
                    // onPressEnter={handleSubmit}
                />
                <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'start' }}>
                    <SpinnerButton
                        title="Submit"
                        disabled={passwordFirst === '' || passwordSecond === ''}
                        submitting={submitting}
                        onClick={handleSubmit}
                    />
                </div>
                <div className="mt-2 text-decoration-underline cursor-pointer" onClick={() => history.push('/signin')}>
                    Return to Login
                </div>
            </div>
        </div>
    );
};


const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateToProps,
    { login, setPermissions, logoutWithoutRedirect }
)(InviteUserPage);
